export default __webpack_public_path__ + "pgnv-assets/d757e344e548ffcfc66f87e78c73ef95.png";